import { Dispatch } from 'redux';
import { Filter } from '../../models/Flight/Filters';
import { OrderedMap } from 'immutable';

export const FLIGHT_CLEAR_FILTERS = 'FLIGHT_CLEAR_FILTERS';
export const FLIGHT_SET_FILTERS = 'FLIGHT_SET_FILTERS';
export const FLIGHT_INIT_FILTERS = 'FLIGHT_INIT_FILTERS';

export const setFiltersAction = (filterName: string, filterValue: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: FLIGHT_SET_FILTERS,
        filterName,
        filterValue
    });
};

export const clearFiltersAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: FLIGHT_CLEAR_FILTERS
    });
};

export const initFlightFiltersAction = (filters: OrderedMap<string, Filter>) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: FLIGHT_INIT_FILTERS,
        filters
    });
};



// WEBPACK FOOTER //
// ./src/actions/Flight/filters.ts